<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Submit'"
    cancel-btn-text="Close"
    :is-submit-btn="false"
  >
    <template slot="header">
      <span>Contacts</span>
    </template>
    <template slot="body">
      <div class="d-flex flex-column pa-2">
        <div
          v-for="(contact, i) in contacts.filter(x => !x.is_deleted)"
          :key="`contact-${contact.name}-${i}`"
          class="d-flex flex-column pb-2"
        >
          <div
            v-if="editContact !== contact"
            class="d-flex align-center justify-space-between pa-2"
            style="border: 1px solid rgba(0,0,0,0.6); border-radius: 4px;"
          >
            <span style="font-size: 18px;">{{ contact.name }}</span>

            <div class="d-flex align-center">
              <v-btn
                outlined
                small
                class="mr-1"
                color="error"
                @click="softDelete(contact)"
              >
                Delete
              </v-btn>
              <v-btn
                color="primary"
                outlined
                small
                @click="edit(contact)"
              >
                Edit
              </v-btn>
            </div>
          </div>
          <v-text-field
            v-else
            v-model="contactName"
            label="Name"
            outlined
            dense
            :rules="[(v) => !!v || 'Contact Name is required']"
          >
            <template #append>
              <div class="d-flex align-center">
                <v-btn
                  outlined
                  small
                  class="mr-1"
                  @click="cancel"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  small
                  @click="submit"
                >
                  Submit
                </v-btn>
              </div>
            </template>
          </v-text-field>
        </div>
        <div>
          <v-btn
            v-if="editContact == null"
            block
            class="elevation-0"
            outlined
            color="primary"
            @click="openNew"
          >
            Add Contact
          </v-btn>
        </div>
      </div>
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data: () => ({
    editContact: null,
    contactName: null,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  props: ['contacts'],
  created() {
    
  },
  methods: {
    submit() {
      this.editContact.name = this.contactName;
      this.editContact = null;
      this.contactName = null;
    },

    open() {
      this.$refs.dialogBox.open();
    },

    openNew() {
      this.contacts.push({ id: null, name: '', is_deleted: 0 });
    },

    edit(contact) {
      this.editContact = contact;
      this.contactName = contact.name;
    },

    cancel() {
      this.editContact = null;
      this.contactName = null;
    },

    async softDelete(contact) {
      contact.is_deleted = 1;
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner
{
  margin-top: 6px;
}
</style>
